import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'reverse' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/reverse.js.map
